import type { LocationId } from '@brightlocal/shared';

import { LOCATION_QUERY_KEY, LOCATION_STALE_TIME } from './consts';
import { fetchLocation } from './utils/locationQueryFn';

/** Query options for fetching a single location by ID. Use with ensureQueryData (loader) or useQuery (hooks). */
export const locationQuery = (id: LocationId) => ({
  queryKey: [LOCATION_QUERY_KEY, id] as const,
  queryFn: ({ signal }: { signal: AbortSignal }) => fetchLocation({ locationId: id, signal }),
  staleTime: LOCATION_STALE_TIME
});
